import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MsalService } from "@azure/msal-angular";
import { AuthService } from "../services/auth.service";
import { catchError, EMPTY, from, Observable, switchMap } from "rxjs";
import { AuthenticationResult } from "@azure/msal-browser";

@Injectable()
export class IdTokenInterceptor implements HttpInterceptor {
  constructor(private msalService: MsalService, private authService: AuthService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const idToken = this.msalService.instance.getActiveAccount()?.idToken;

    if (idToken) {
      const claims = this.msalService.instance.getActiveAccount()?.idTokenClaims as any;
      const now = Math.floor(Date.now() / 1000);
      
      if (claims && claims.exp && claims.exp < now) {
        // Token expired, acquire new token
        return from(this.authService.acquireTokenSilently()).pipe(
          switchMap((result: AuthenticationResult | null) => {
            if (result && result.idToken) {
              const clonedRequest = req.clone({
                setHeaders: {
                  Authorization: `Bearer ${result.idToken}`,
                },
              });
              return next.handle(clonedRequest);
            }
            this.authService.logout();
            return EMPTY;
          }),
          catchError(() => {
            this.authService.logout();
            return EMPTY;
          })
        );
      } else {
        const clonedRequest = req.clone({
          setHeaders: {
            Authorization: `Bearer ${idToken}`,
          },
        });
        return next.handle(clonedRequest);
      }
    }

    return next.handle(req);
  }
}
